<template>
  <div class="row">
    <div class="col-12">
      <q-chip
        v-for="(process, idx) in assessPlan.processes"
        :key="idx"
        :removable="editable&&!disabled"
        :color="process.selected ? 'primary' : 'grey-6'"
        text-color="white"
        icon="memory"
        :selected.sync="process.selected"
        :label="process.processName"
        :title="process.processName"
        v-model="process.check"
        @remove="state => removeProcess(state, process)"
        @update:selected="state => selectedProcess(state, process, idx)"
      >
        <q-tooltip>{{ process.processName }}</q-tooltip>
      </q-chip>
      <q-chip
        v-if="editable&&!disabled"
        clickable
        color="orange"
        text-color="white"
        icon="add"
        label="추가"
        title="추가"
        @click="addProcess"
      />
    </div>
    <div class="col-12">
      <c-tab
        type="tabcard"
        align="left"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        v-model="tab"
      >
        <template v-slot:default="tab">
          <component
            :is="tab.component"
            :process.sync="process"
            :disabled.sync="disabled"
            @saveProcess="saveProcess"
          />
        </template>
      </c-tab>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'kpsr-target-process',
  props: {
    assessPlan: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        ramStepCd: '',
        processes: [], // 대상공정 목록
      }),
    },
    searchFlag: {
      type: Object,
      default: () => ({
        value: '',
      }),
    },
  },
  data() {
    return {
      process: {
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        regUserId: '',  // 작성자 ID
        chgUserId: '',  // 수정자 ID
        equipments: [],
        drawNodes: [],
      },
      saveProcessCd: '',
      tab: 'process',
      tabItems: [
        { name: 'process', icon: 'work_outline', label: '대상공정', component: () => import(`${'./kpsrTargetProcessDetail.vue'}`) },
        { name: 'jobRisk', icon: 'work_outline', label: '도면 및 노드', component: () => import(`${'./kpsrTargetPidNode.vue'}`) },
      ],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '50%',
        param: {},
        closeCallback: null,
      },
      editable: true,
      saveUrl: '',
      deleteUrl: '',
    };
  },
  computed: {
    disabled() {
      return Boolean(this.assessPlan.ramStepCd !== 'RKS000001' && this.assessPlan.ramStepCd)
    }
  },
  watch: {
    'assessPlan.processes': {
      handler: function () {
        if (this.saveProcessCd && this.$_.findIndex(this.assessPlan.processes, { processCd: this.saveProcessCd }) > -1) {
          this.assessPlan.processes[this.$_.findIndex(this.assessPlan.processes, { processCd: this.saveProcessCd })].selected = true
        }
      },
      deep: true,
    },
    'searchFlag.value': {
      handler: function () {
        if (this.assessPlan.processes && this.assessPlan.processes.length > 0) {
          this.selectedProcess(true, this.assessPlan.processes[0], 0)
        }
      },
      deep: true,
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.saveUrl = transactionConfig.ram.assessProcess.insert.url;
      this.deleteUrl = transactionConfig.ram.assessProcess.delete.url;
      // code setting
      // list setting
      if (this.assessPlan.processes && this.assessPlan.processes.length > 0) {
        this.selectedProcess(true, this.assessPlan.processes[0], 0)
      }
    },
    removeProcess(state, process) {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '제외하실 경우 해당 공정에 해당하는\n\r평가대상 목록도 변경됩니다.\n\r진행하시겠습니까? ',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: process,
          };
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('saveCallback', this.assessPlan.ramRiskAssessmentPlanId)
            Object.assign(this.$data.process, this.$options.data().process);
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
          process.check = true
        },
      });
    },
    addProcess() {
      this.popupOptions.title = '단위공정 검색';
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/process/processPop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeProcessPopup;
    },
    closeProcessPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let saveData = this.$_.filter(data, (item) => {
          return this.$_.findIndex(this.assessPlan.processes, { processCd: item.processCd }) === -1
        })
        this.$_.forEach(saveData, item => {
          item.ramRiskAssessmentPlanId = this.assessPlan.ramRiskAssessmentPlanId;
          item.ramProcessAssessStepCd = 'RPA0000001';
          item.regUserId = this.$store.getters.user.userId;
        })
        this.$http.url = this.saveUrl;
        this.$http.type = 'POST';
        this.$http.param = saveData;
        this.$http.request(() => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          this.$emit('saveCallback', this.assessPlan.ramRiskAssessmentPlanId)
        },);
      }
    },
    /**
     * chip 라이브러리 사용
     * 공정을 클릭 했을 시에 해당 공정이 클릭되었음을 표시하게끔 배경색을 변경시키며
     * 다른 공정들은 selected false 처리 및 색상 primary로 변경
     */
    selectedProcess(state, process, idx) {
      if (this.saveProcessCd) {
        this.saveProcessCd = ''
      }
      if (state) {
        this.assessPlan.processes.forEach((item, index) => {
          if (idx !== index) {
            this.$set(item, 'selected', false)
          } else {
            this.$set(item, 'selected', true)
            this.process = process;
          }
        })
      } else {
        this.$set(this.assessPlan.processes[idx], 'selected', true)
      }
    },
    saveProcess(processCd) {
      this.saveProcessCd = processCd;
      this.$emit('saveCallback', this.assessPlan.ramRiskAssessmentPlanId)
    },
  }
};
</script>
